import jwt_decode from 'jwt-decode';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CurrentUserDto } from '../../models/current-user.model';
import { Roles } from '../../models/roles.enum';
import { BaseComponent } from '../../components/component-base';
import { AuthService } from './auth.service';
import { ApiResponse } from '../../models/api-response.model';
import { CacheService } from '../cashe-service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard extends BaseComponent implements CanActivate {
  constructor(public override router?: Router,
    public override authService?: AuthService) {
    super();
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let requiredRoles = route.data.roles as Array<string>;

    // var LoginStatus =  CacheService.getLoginStatus(); 
    if(!CacheService.getToken())
    {
      return this.router.navigate(['/auth/login']);
    }
    if (requiredRoles) {
      if (this.checkAuthenticated(requiredRoles)) {
        return true;
      }
      return this.router.navigate(['/401']);
    }
    else{
      if (this.checkAuthenticated(requiredRoles)) {
      return true;
    }
    }
    return true;
  }

  checkAuthenticated(requiredRoles) {
    var ddd = CacheService.IsAuthorize(requiredRoles);
    return ddd;
    // return this.IsAuthorize(requiredRoles);
  }
}
